<template lang="pug">
tbody.thead
  tr
    th(v-if="walker.sub_show") {{ walker.sub_label }}
    th {{ walker.third_label }}
    th(v-if="tableShowStatus") Status
    th(v-if="tableShowStartsAt") Started
    th(v-if="tableShowStopsAt") Ended
    th(v-if="tableShowAllotted") Allotted (hrs)
    th(v-if="tableShowActualLength") Actual (hrs)
    th(v-if="tableShowPaidLength") Paid (hrs)
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'WorkBreaksReportTableHeader',
  computed: {
    ...mapGetters([
      'walker',
      'tableShowStatus',
      'tableShowStartsAt',
      'tableShowStopsAt',
      'tableShowAllotted',
      'tableShowActualLength',
      'tableShowPaidLength',
    ]),
  },
};
</script>
